import { render, staticRenderFns } from "./bankTxImportPage.vue?vue&type=template&id=0485b47e&"
import script from "./bankTxImportPage.vue?vue&type=script&lang=ts&"
export * from "./bankTxImportPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports